import { render, staticRenderFns } from "./QuestionMedia.vue?vue&type=template&id=521011d8&scoped=true"
import script from "./QuestionMedia.vue?vue&type=script&lang=js"
export * from "./QuestionMedia.vue?vue&type=script&lang=js"
import style0 from "./QuestionMedia.vue?vue&type=style&index=0&id=521011d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521011d8",
  null
  
)

export default component.exports